import { useFormContext } from 'react-hook-form';

import { DatePickerInput } from '#atoms';

import Checkbox from 'src/refactor_shared/ui/checkbox';
import Title from 'src/refactor_components/common/Title';

import { parseDateToYearMonth } from 'src/refactor_shared/lib/parseYear';
import PdfUpload from 'src/refactor_shared/ui/PdfUpload';

const QualificationDegree = () => {
  const methods = useFormContext();

  return (
    <>
      <div className="flex flex-col gap-8">
        <Title text="학교명" essential={true} />
        <input
          {...methods.register('name', { required: true })}
          className="focus:bg-white focus:text-black w-full bg-transparent border border-[#494949] p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999]"
          placeholder="학교명을 입력해주세요"
        />
      </div>
      <div className="flex flex-col gap-8">
        <Title text="전공" essential={true} />
        <input
          {...methods.register('major', { required: true })}
          className="focus:bg-white focus:text-black w-full bg-transparent border border-[#494949] p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999]"
          placeholder="전공을 입력해주세요"
        />
      </div>

      <div className="flex flex-col gap-16 items-start">
        <div className="flex gap-12 w-full">
          <div className="w-1/2 flex flex-col gap-8">
            <Title text="입학" essential={true} />
            <DatePickerInput
              required
              title="입학 연월"
              onlyYearMonth
              onChange={date => {
                methods.setValue('from', date.toISOString());
              }}
            >
              <div className="text-[#999] p-16 border border-solid border-[#494949] rounded-5">
                <input
                  className="hidden"
                  {...methods.register('from', { required: true })}
                  disabled
                />
                <div className="">
                  {methods.watch('from')
                    ? parseDateToYearMonth(methods.getValues('from'))
                    : '입학 연월'}
                </div>
              </div>
            </DatePickerInput>
          </div>
          {!methods.watch('hasEnded') ? (
            <div className="w-1/2 flex flex-col gap-8">
              <Title text="졸업" essential={true} />
              <DatePickerInput
                required
                title="졸업 연월"
                onlyYearMonth
                onChange={date => {
                  methods.setValue('at', date.toISOString());
                }}
              >
                <div className="text-[#999] p-16 border border-solid border-[#494949] rounded-5">
                  <input
                    className="hidden"
                    {...methods.register('at', {
                      required: !methods.watch('hasEnded')
                    })}
                    disabled
                  />
                  <div className="">
                    {methods.watch('at')
                      ? parseDateToYearMonth(methods.getValues('at'))
                      : '졸업 연월'}
                  </div>
                </div>
              </DatePickerInput>
            </div>
          ) : null}
        </div>
        <Checkbox registerName="hasEnded" labelTitle="재학중" />
      </div>

      <PdfUpload registerName="images" titleText="증명자료 제출" />
    </>
  );
};

export default QualificationDegree;
